// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  name: __t.string(),
  description: __t.string(),
  color: __t.string(),
  restricted: __t.bool(),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  scopeId: __t.string().name("scope_id"),
  createdByUserId: __t.string().name("created_by_user_id"),
});
